import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { DuplicateEstimateMutation as DuplicateEstimateMutationResult } from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const DuplicateEstimateMutation = graphql(`
  mutation DuplicateEstimate($id: ID!) {
    duplicateEstimate(id: $id) {
      id
    }
  }
`);

const useDuplicateEstimate = (args: {
  projectId: string;
  options?: UseMutationOptions<
    DuplicateEstimateMutationResult,
    Error,
    { id: string }
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation({
    mutationFn: (variables: { id: string }) => {
      return gqlClient.request(DuplicateEstimateMutation, variables);
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.estimates(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useDuplicateEstimate;
